import { useCallback } from "react";
import { useNavigate, useParams, useLocation } from "react-router";
import {
  createQueryParamsFromApiFilters,
  preserveAndAppendLabelPropagationParams,
} from "helpers/utility/savedViewsUtils";
import {
  PAGE_PARAMETER,
  SAVED_VIEW_PARAMETER,
} from "helpers/constants/miscellaneous";
import { SavedView } from "types";
import { amplitudeTrack } from "../helpers/utility/amplitude";
import { AMP_SAVED_VIEWS_EVENT__VIEW_EXPLORED } from "../helpers/constants/amplitudeEvents";

const useNavigateToView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { viewsDatasetId, datasetId } = useParams();

  const navigateToView = useCallback(
    (view: SavedView) => {
      let url = `/dataset/${viewsDatasetId || datasetId}/data`;
      if (view.filters.cluster_id) {
        url = url + `/cluster/${view.filters.cluster_id}`;
      }
      const queryParams = createQueryParamsFromApiFilters(view.filters);
      const hasPageParam = queryParams.includes(`${PAGE_PARAMETER}=`);

      url = url + queryParams;

      // Add page parameter if not already present
      if (!hasPageParam) {
        url += (queryParams.length > 1 ? "&" : "") + `${PAGE_PARAMETER}=1`;
      }

      // Preserve seed and flow parameters from current URL for label propagation
      url = preserveAndAppendLabelPropagationParams(url, location.search);

      url += `&${SAVED_VIEW_PARAMETER}=${view.id}`;
      navigate(url);
      amplitudeTrack(AMP_SAVED_VIEWS_EVENT__VIEW_EXPLORED);
    },
    [navigate, viewsDatasetId, datasetId, location.search],
  );

  return navigateToView;
};

export default useNavigateToView;
